import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { azureAuthentication } from 'utils/functions/authentication';
import LoginPage from 'pages/LoginPage';
import AuthenticationPage from 'pages/AuthenticationPage';

const { validateUser } = azureAuthentication();

const LoginRoute = () => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(null);

  useEffect(() => {
    validateUser().then(result => {
      const { isValidUser } = result;
      setIsUserAuthenticated(isValidUser);
    });
  }, []);

  if (isUserAuthenticated === true) return <Navigate to="/advertisers" />;

  if (isUserAuthenticated === false) return <LoginPage />;

  return <AuthenticationPage />;
};

export default LoginRoute;
